import { default as documentApi } from '../common/serviceApi';

const oneShotPrompt = (answers) => {
    const prompt =
    'We are a ' + answers[0].value+ ' looking to hire a ' +answers[1].value+ ' for our team. Some of the important tasks this person will need to do on a weekly basis include: ' +answers[2].value+'. This person should have the following skills: '+answers[3].value+'. \n'+
    '\n'+
    'My minimum qualifications for this role include: ' +answers[4].value+'. Additionally, the ideal candidate should possess these characteristics: '+answers[5].value.labels+'\n'+
    '\n'+
    'I will know if this person is successful in the role if this person is able to achieve the following tangible outcomes: '+answers[6].value+'\n'+
    '\n'+
    'Given this, please provide an effective and attractive job description for this role, specific to my company. Aside from what I have written in my prompt, please bolster the job description with any relevant and highly accurate information from your knowledge.\n'+
    '\n'+
    'Use the following format for your response:\n'+
    '\n'+
    'Job Title: [appropriate job title]\n'+
    '\n'+
    'Role:\n'+
    '\n'+
    'Responsibilities:\n'+
    '\n'+
    '[responsibility 1]\n'+
    '\n'+
    '[responsibility 2]\n'+
    '\n'+
    '[responsibility 3]\n'+
    '\n'+
    '[responsibility 4]\n'+
    '\n'+
    '[responsibility 5]\n'+
    '\n'+
    '[responsibility 6]\n'+
    '\n'+
    '[responsibility 7]\n'+
    '\n'+
    '[responsibility 8]\n'+
    '\n'+
    '[responsibility 9]\n'+
    '\n'+
    '[responsibility 10]\n'+
    '\n'+
    '4. Results:\n'+
    '\n'+
    '[measurable outcome 1]\n'+
    '\n'+
    '[measurable outcome 2]\n'+
    '\n'+
    '[measurable outcome 3]\n'+
    '\n'+
    '[measurable outcome 4]\n'+
    '\n'+
    '[measurable outcome 5]\n'+
    '\n'+
    '5. Requirements:\n'+
    '\n'+
    '[requirement 1]\n'+
    '\n'+
    '[requirement 2]\n'+
    '\n'+
    '[requirement 3]\n'+
    '\n'+
    '[requirement 4]\n'+
    '\n'+
    '[requirement 5]';
  
    return prompt;
}

const getResponsePrompt = (prompt, options={timeout: 180000}) => {
    const promptObject = {
      "prompt": prompt
    };

    const buildMiiChatConfig = {
      model: "gpt-3.5-turbo-1106",
      messages: [
        {role: "system", content: "You are a Hiring Manager with extensive experience. You have been provide with the following information:"},
        {role: "user", content: prompt }
      ],
      temperature: 1,
      max_tokens: 2000,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0    
    }
  
    console.log("buildMiiChatConfig",buildMiiChatConfig)
  
    const maxRetries = 3; // Maximum number of retries
    const initialDelay = 1000; // Initial delay in milliseconds
  
    const executeRequestWithBackoff = (retryCount, delay) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          documentApi.post(`/chat`, buildMiiChatConfig, options)
            .then(response => {
              const headers = response.headers;
              const rateLimitToken = headers['rate-limit-token'];
              const rateLimitRefreshToken = headers['rate-limit-refresh-token'];
              resolve({
                description: response.data?.description, 
                rateLimitToken: rateLimitToken, 
                rateLimitRefreshToken:rateLimitRefreshToken})
            })
            .catch(error => {
              if (retryCount >= maxRetries) {
                reject({ error: error?.response?.data });
              } else {
                const nextDelay = delay * 2; // Increase delay exponentially
                executeRequestWithBackoff(retryCount + 1, nextDelay)
                  .then(resolve)
                  .catch(reject);
              }
            });
        }, delay);
      });
    };
  
    return executeRequestWithBackoff(0, initialDelay);
};

const getBuildMiiOneShotJobDescriptionRequest = async(prompt,answers, options={timeout: 180000}) => {
    const getPrompt = oneShotPrompt(answers)
    const finalPrompt = prompt + getPrompt
    return await getResponsePrompt(finalPrompt,options)

  }

  const getBuildMiiTypeFormResponseRequest = async(uuid, options={timeout: 180000}) => {
    return await documentApi.get(`/typeform/responses/${uuid}`, options, { 
    }).then(response => {
        return response
    }).catch(error => {

      return error
    })
  }

  const getBuildMiiTypeFormConfigurationRequest = async(formId, options={timeout: 180000}) => {
    return await documentApi.get(`/typeforms/${formId}`, options, { 
    }).then(response => {
        return response
    }).catch(error => {
      return error
    })
  }

  export const useBuildMiiTestService = () => {
    const options = {}
    const services = {
      getBuildMiiOneShotJobDescriptionRequest,
      getBuildMiiTypeFormResponseRequest,
      getBuildMiiTypeFormConfigurationRequest
    }

    return [
       { ...services}
    ]
  }

  export const useBuildMiiTest = () => {
    const [  handlers ] = useBuildMiiTestService()
    return [ handlers ]
  }